import React, { useEffect } from 'react';
import { FaMotorcycle, FaUsers, FaShieldAlt, FaLeaf, FaHeart } from 'react-icons/fa';

const About = () => {
  useEffect(() => {
    document.title = "About Us - SastaMastaRide";
  }, []);

  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      <div className="bg-white rounded-lg shadow-lg p-6 sm:p-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-6">About SastaMastaRide</h1>
        
        <div className="bg-blue-50 p-4 rounded-lg mb-6 border-l-4 border-blue-600">
          <p className="text-sm text-gray-700">
            <strong>Note:</strong> This website is operated by <strong>SastaMastaRide</strong>, managed by <strong>RKTECH Solutions</strong>.
          </p>
        </div>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6 text-lg">
            SastaMastaRide is India's leading affordable two-wheeler ridesharing platform, connecting riders and passengers 
            for shared rides on bikes, scooters, and cars. Our mission is to make transportation more affordable, 
            eco-friendly, and social.
          </p>

          <div className="bg-gray-50 p-6 rounded-lg mb-6">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Company Information</h2>
            <div className="space-y-2 text-gray-700">
              <p><strong>Legal Entity Name:</strong> [Your Legal Name as per Aadhar]</p>
              <p><strong>Operating Name:</strong> SastaMastaRide</p>
              <p><strong>Managed By:</strong> RKTECH Solutions</p>
              <p><strong>Registered Address:</strong> [Your Registered Address], India</p>
              <p><strong>Contact Email:</strong> info@sastamastaride.com</p>
              <p><strong>Contact Phone:</strong> +91-1800-XXX-XXXX</p>
              <p><strong>GSTIN:</strong> [Your GST Number if applicable]</p>
              <p><strong>CIN:</strong> [Your Company Identification Number if applicable]</p>
            </div>
          </div>

          <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Our Mission</h2>
          <p className="text-gray-600 mb-6">
            We believe in creating a sustainable future by reducing the number of vehicles on the road, 
            cutting down carbon emissions, and making daily commutes more affordable for everyone. 
            By connecting riders and passengers, we're building a community that shares not just rides, 
            but also experiences and friendships.
          </p>

          <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">What We Offer</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="bg-blue-50 p-6 rounded-lg">
              <FaMotorcycle className="text-blue-600 text-3xl mb-3" />
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Bike Sharing</h3>
              <p className="text-gray-600">
                Connect with bike riders and passengers for affordable shared rides across the city.
              </p>
            </div>
            <div className="bg-green-50 p-6 rounded-lg">
              <FaUsers className="text-green-600 text-3xl mb-3" />
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Scooter Sharing</h3>
              <p className="text-gray-600">
                Share scooter rides and split the cost, making your daily commute more economical.
              </p>
            </div>
            <div className="bg-purple-50 p-6 rounded-lg">
              <FaShieldAlt className="text-purple-600 text-3xl mb-3" />
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Safe & Verified</h3>
              <p className="text-gray-600">
                All riders are verified and background-checked to ensure your safety and security.
              </p>
            </div>
            <div className="bg-yellow-50 p-6 rounded-lg">
              <FaLeaf className="text-yellow-600 text-3xl mb-3" />
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Eco-Friendly</h3>
              <p className="text-gray-600">
                Reduce your carbon footprint by sharing rides and contributing to a greener environment.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Why Choose SastaMastaRide?</h2>
          <ul className="list-disc list-inside text-gray-600 space-y-2 mb-6">
            <li>Affordable rides - Split costs and save money on your daily commute</li>
            <li>Verified riders - All riders go through a verification process</li>
            <li>Real-time tracking - Track your ride in real-time for added security</li>
            <li>Secure payments - Multiple payment options with secure transactions</li>
            <li>24/7 support - Our support team is always ready to help</li>
            <li>Eco-friendly - Reduce carbon emissions by sharing rides</li>
          </ul>

          <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Our Values</h2>
          <div className="bg-gray-50 p-6 rounded-lg mb-6">
            <p className="text-gray-600 mb-4">
              At SastaMastaRide, we are committed to:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li><strong>Safety First:</strong> Your safety is our top priority. We verify all riders and provide safety guidelines.</li>
              <li><strong>Community Building:</strong> We believe in building a strong community of riders and passengers.</li>
              <li><strong>Sustainability:</strong> We're committed to reducing environmental impact through shared transportation.</li>
              <li><strong>Transparency:</strong> Clear pricing, honest reviews, and transparent policies.</li>
              <li><strong>Innovation:</strong> Continuously improving our platform to provide the best experience.</li>
            </ul>
          </div>

          <div className="bg-blue-600 text-white p-6 rounded-lg mt-8 text-center">
            <FaHeart className="inline text-red-300 text-2xl mb-2" />
            <p className="text-lg">
              Join thousands of riders and passengers who are making transportation more affordable, 
              social, and sustainable. Start your journey with SastaMastaRide today!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;

